import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ColumnHiddenFilterPipe,
  PublicRegistryTableComponent,
} from 'pages/public-registry/public-registry-table/public-registry-table.component';
import {
  PublicRegistryRecordComponent
} from 'pages/public-registry/public-registry-record/public-registry-record.component';
import {
  PublicRegistryBlockElementComponent
} from 'pages/public-registry/public-block-element/public-registry-block-element.component';
import { OrganizationService } from 'services/organization/organization.service';
import {
  PublicRegistryRecordResolverService,
  PublicRegistryResolverService,
} from 'pages/public-registry/public-registry-resolver.service';
import { RegistryTableModule } from 'components/registry-table/registry-table.module';
import { CertemyCommonModule } from 'common/certemy-common.module';
import {
  DisplayHtmlModule,
  IconModule,
  SearchInputModule, SelectModule,
  SmartFiltersModule,
  TypeaheadModule,
} from '@certemy/ui-components';
import { AlphabetFilterModule } from 'components/alphabet-filter/alphabet-filter.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SidebarFiltersModule } from 'components/sidebar-filters/sidebar-filters.module';
import { NoContentModule } from 'components/no-content/no-content.module';
import { MessageBlockModule } from 'components/message-block/message-block.module';
import { MobilePlaceholderModule } from 'components/mobile-placeholder/mobile-placeholder.module';
import { ReportGenerateModule } from 'features/report-generate/report-generate.module';

@NgModule({
  declarations: [
    PublicRegistryTableComponent,
    PublicRegistryRecordComponent,
    PublicRegistryBlockElementComponent,
    ColumnHiddenFilterPipe,
  ],
  providers: [OrganizationService, PublicRegistryResolverService, PublicRegistryRecordResolverService],
  imports: [
    CommonModule,
    RegistryTableModule,
    CertemyCommonModule,
    SearchInputModule,
    AlphabetFilterModule,
    NgbModule,
    IconModule,
    SmartFiltersModule,
    SidebarFiltersModule,
    NoContentModule,
    TypeaheadModule,
    MessageBlockModule,
    MobilePlaceholderModule,
    DisplayHtmlModule,
    ReportGenerateModule,
    SelectModule,
  ],
  exports: [
    PublicRegistryTableComponent,
    PublicRegistryRecordComponent,
    PublicRegistryBlockElementComponent,
  ]
})
export class PublicRegistryTableModule { }
